
import NavigationBar from "../NavigationBar";
import Footer from "../Footer";


function MainLayout({ children }) {
    return (
        <div className="d-flex flex-column min-vh-100">
            <NavigationBar />

            <div className="flex-fill" style={{ marginTop: "56px" }}>
                {children}
            </div>

            <Footer />
        </div>
    );
}

export default MainLayout;
